<template>
  <!-- 修改卸货作业单 -->
  <div class="editSheet_content">
    <div class="dispatch_head">
      <div class="topBtns">
        <el-button
          style="margin-top: 10px"
          class="glo_bgcMainColor"
          @click="submit('SAVE')"
          v-if="!intoStoreage"
          >保存</el-button
        >
        <el-button
          style="margin-top: 10px"
          class="glo_bg"
          @click="submit('DISPATCH')"
          >卸货入库确认</el-button
        >
      </div>
    </div>
    <el-collapse v-model="activeNames">
      <!-- 发车信息 -->
      <el-collapse-item title="发车信息" name="1">
        <DepartureInformation
          ref="refDepartureInformation"
          :dispatchId="dispatchId"
          :loadOrderId="loadOrderId"
          :canEdit="canEdit"
        ></DepartureInformation>
      </el-collapse-item>
      <!-- 卸货明细 -->
      <el-collapse-item title="卸货明细" name="2">
        <ShipmentDetails
          ref="refShipmentDetails"
          :dispatchId="dispatchId"
          :loadOrderId="loadOrderId"
          :canEdit="canEdit"
          :op="op"
        ></ShipmentDetails>
      </el-collapse-item>
    </el-collapse>
  </div>
</template>

<script>
import vueLs from 'vue-ls';
import DepartureInformation from "./unloadingDepartureInformation.vue";
import ShipmentDetails from "./unloadingShipmentDetails.vue";
export default {
  components: {
    DepartureInformation,
    ShipmentDetails,
  },
  props: {
    loadOrderId: {},
    dispatchId: {},
    canEdit: {},
    op: {},
    prev: {},
  },
  data() {
    return {
      activeNames: ["1", "2"],
    };
  },
  created() {},
  mounted() {},
  computed: {
    intoStoreage() {
      return this.op === "intoStoreage";
    },
  },
  methods: {
    async submit(type) {
      const paramsForm = this.$refs.refDepartureInformation.getForm();
      const waybills = this.$refs.refShipmentDetails.getRows();
      const valid = await this.$refs.refDepartureInformation.validate()
      if(!valid){
        return
      }
      if(!waybills || waybills.length === 0){
        this.$message.error('请添加卸货明细')
      }
      if (!this.loadOrderId) {
        //this.$loading("保存中")
        this.$API
          .addUnLoadOrder({
            ...paramsForm,
            billInfos: waybills,
            orderStatus:
              (type === "SAVE" ? "dai_que_ren" : "yi_que_ren") +
              ":order_status",
          })
          .then((res) => {
            //this.$hideLoading()
            this.$message.success("保存成功");
            if (this.intoStoreage) {
              setTimeout(() => {
                this.$BaseIndex.closeCurrentTab();
                if (this.prev) {
                  this.$router.replace(this.prev);
                }
                this.$BaseIndex.refresh()
              }, 1000);
            } else {
              setTimeout(() => {
                this.$BaseIndex.closeCurrentTab();
                if (this.prev) {
                  this.$router.replace(this.prev);
                }
                this.$BaseIndex.refresh()
              }, 1000);
            }
          })
          .catch((err) => {
            console.log(err)
            this.$message.error(err.data.message);
            //this.$hideLoading()
          });
      } else {
        //this.$loading("保存中")
        this.$API
          .updateUnLoadOrder({
            ...paramsForm,
            billInfos: waybills,
            loadOrderId: this.loadOrderId,
            orderStatus:
              (type === "SAVE" ? "dai_que_ren" : "yi_que_ren") +
              ":order_status",
          })
          .then((res) => {
            //this.$hideLoading()
            this.$message.success("修改成功");
            this.$BaseIndex.closeCurrentTab();
            if (this.prev) {            
              this.$router.replace(this.prev);
            }
            this.$BaseIndex.refresh()
          })
          .catch((err) => {
            this.$message.error(err.data.message);
            //this.$hideLoading()
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.editSheet_content {
  padding-bottom: 50px;
  .dispatch_head {
    height: 50px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #ccc;
    .topBtns {
      background-color: #fff;
      margin-top: -10px;
      // height: 50px;
    }
  }
}
</style>